export interface LogoProps {
  className?: string;
}

export function Logo({ className = "max-h-16 min-h-12 min-w-16 xl:max-h-20 2xl:max-h-24 4xl:max-h-32 object-scale-down shrink-0" }: LogoProps) {
  return (
    <a href="/" className="shrink-0">
      <img
        className={className}
        src="/evtcc-logo.png"
        alt="EVTCC Logo"
      />
    </a>
  );
}